import DashboardPanouPrincipal from "../panou-principal";

export default function DashboardSesizariNevalidate(props) {
  return <DashboardPanouPrincipal filterStatus="not_validated" title="Sesizări nevalidate" {...props} />;
}